import {Lock} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import {cn} from '@chekinapp/ui';

type TrustFooterProps = {
  variant?: 'splash' | 'scene';
  isDark?: boolean;
  kiosk?: boolean;
  className?: string;
};

function TrustFooter({
  variant = 'splash',
  isDark,
  kiosk,
  className,
}: Readonly<TrustFooterProps>) {
  const {t} = useTranslation();
  const isDarkSplash = variant === 'splash' && isDark;

  return (
    <div
      className={cn(
        'absolute inset-x-0 bottom-[26px] flex flex-col items-center gap-1.5',
        className,
      )}
    >
      <div
        className={cn(
          'flex items-center gap-[7px] text-[11.5px] font-semibold',
          kiosk && 'kiosko:text-[16px]',
          isDarkSplash
            ? 'text-[color:var(--sp-ink-soft)]'
            : 'text-[color:var(--chekin-text-secondary)]',
        )}
      >
        <Lock
          size={13}
          className={cn(
            kiosk && 'kiosko:size-[18px]',
            isDarkSplash
              ? 'text-[color:var(--chekin-green-500)]'
              : 'text-[color:var(--chekin-green-700)]',
          )}
        />
        {t('splash_secure_check_in')}
      </div>
      <div
        className={cn(
          'text-[10.5px] font-medium tracking-[0.01em]',
          kiosk && 'kiosko:text-[13px]',
          variant === 'splash'
            ? 'text-[color:var(--sp-ink-faint)]'
            : 'text-[color:var(--chekin-text-tertiary)]',
        )}
      >
        {t('splash_powered_by_chekin')}
      </div>
    </div>
  );
}

export {TrustFooter};
